import { Button } from '@lideralia/alife-uikit/dist/atoms/Button';
import { Icon } from '@lideralia/alife-uikit/dist/atoms/Icon';
import { IconConfiguration } from '@lideralia/alife-uikit/dist/atoms/Icons';
import IconNotification from '@lideralia/alife-uikit/dist/atoms/Icons/IconNotification';
import IconPower from '@lideralia/alife-uikit/dist/atoms/Icons/IconPower';
import IconStop from '@lideralia/alife-uikit/dist/atoms/Icons/IconStop';
import IconUser from '@lideralia/alife-uikit/dist/atoms/Icons/IconUser';
import { Box, Container } from '@lideralia/alife-uikit/dist/atoms/Layout';
import { Text } from '@lideralia/alife-uikit/dist/atoms/Typography';
import { CollapsiblePanel } from '@lideralia/alife-uikit/dist/molecules/Layout/CollapsiblePanel';
import { CardGoneBasic } from '@lideralia/alife-uikit/dist/organisms/Cards';
import css from '@styled-system/css';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { deleteLocalStorage } from '../../../common/functions/cookies';
import { actualLanguage } from '../../../common/functions/lang';
import { postLogout } from '../../../common/schemes/user';

const BadgeStyled = styled(Text)(
  css({
    backgroundColor: 'red',
    paddingY: 1,
    paddingX: 2,
    borderRadius: 7,
    color: 'white',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  })
);

const UppercaseBox = styled(Box)`
  text-transform: uppercase;
`;

const Title = ({children}) => (
  <UppercaseBox fontSize={3} fontWeight="bold" color="black96">
    {children}
  </UppercaseBox>
);

const Divider = styled('div')(
  css({
    backgroundColor: '#B2B2B9',
    width: '100%',
    height: '1px',
    marginTop: 4,
    marginBottom: 3,
  })
);

export const ProfileTemplate = (props) => {
  const lines = useSelector((state) => state.lines);
  const {
    actionPersonalZone,
    actionNotifications,
    actionModeration,
    actionConfiguration,
    // actionSettings,
    haveNotifications,
    active,
    moderation,
  } = props;

  return (
    <Container paddingY={3} paddingBottom={11} maxWidth={['400px']} {...props}>
      <MyLines lines={lines?.all} />
      <Divider />
      <PersonalZone
        actionNotifications={actionNotifications}
        haveNotifications={haveNotifications}
        actionPersonalZone={actionPersonalZone}
      />
      <Divider />
      {active && active.permissionType > 2 && (
        <>
          <AdministratorsZone
            moderation={moderation}
            actionModeration={actionModeration}
            actionConfiguration={actionConfiguration}
          />
          <Divider />
        </>
      )}
      <Logout />
    </Container>
  );
};

const AdministratorsZone = ({ actionModeration, moderation, actionConfiguration }) => (
  <>
    <Title>
      <FormattedMessage id="profile.administratorsZone.title" />
    </Title>
    <Box marginTop={2}>
      <Button
        marginY={2}
        fullWidth
        colorType="white"
        sizeButton="big"
        justifyContent="flex-start"
        action={() => actionModeration()}
      >
        <Icon sizeIcon="display24" color="black84">
          <IconStop />
        </Icon>
        <Text
          textAlign="left"
          style={{ flex: 1 }}
          marginLeft={2}
          fontWeight="bold"
          sizeText="display16"
          color="black84"
        >
          <FormattedMessage id="communication.moderation.title" />
        </Text>
        {(moderation?.length && (
          <BadgeStyled fontWeight="bold" sizeText="display12">
            {moderation.length}
          </BadgeStyled>
        )) ||
          ''}
      </Button>
      <Button
        marginY={2}
        fullWidth
        colorType="white"
        sizeButton="big"
        justifyContent="flex-start"
        action={() => actionConfiguration()}
      >
        <Icon sizeIcon="display24" color="black84">
          <IconConfiguration />
        </Icon>
        <Text
          textAlign="left"
          style={{ flex: 1 }}
          marginLeft={2}
          fontWeight="bold"
          sizeText="display16"
          color="black84"
        >
          <FormattedMessage id="communication.configuration.title" />
        </Text>
        {(moderation?.length && (
          <BadgeStyled fontWeight="bold" sizeText="display12">
            {moderation.length}
          </BadgeStyled>
        )) ||
          ''}
      </Button>
    </Box>
  </>
);

const PersonalZone = ({ actionNotifications, haveNotifications, actionPersonalZone }) => (
  <>
    <Title>
      <FormattedMessage id="profile.personalZone.title" />
    </Title>
    <Box marginTop={2}>
      <Button
        marginY={1}
        fullWidth
        colorType="white"
        sizeButton="big"
        justifyContent="flex-start"
        action={() => actionNotifications()}
        id="notifications"
      >
        <Icon sizeIcon="display24" color="black84">
          <IconNotification />
        </Icon>
        <Text
          textAlign="left"
          style={{ flex: 1 }}
          marginLeft={2}
          fontWeight="bold"
          sizeText="display16"
          color="black84"
        >
          <FormattedMessage id="profile.notifications.title" />
        </Text>
        {(haveNotifications && (
          <BadgeStyled fontWeight="bold" sizeText="display12">
            {haveNotifications}
          </BadgeStyled>
        )) ||
          ''}
      </Button>
      <Button
        id="personalZone"
        marginY={2}
        fullWidth
        colorType="white"
        sizeButton="big"
        justifyContent="flex-start"
        action={() => actionPersonalZone()}
      >
        <Icon sizeIcon="display24" color="black84">
          <IconUser />
        </Icon>
        <Text marginLeft={2} fontWeight="bold" sizeText="display16" color="black84">
          <FormattedMessage id="profile.personalData.title" />
        </Text>
      </Button>
    </Box>
  </>
);

const MyLines = ({ lines }) => {
  const history = useHistory();
  const numLines = lines?.length;
  const adminLines = lines?.filter((element) => element.permissionType >= 3);
  const followerLines = lines?.filter((element) => element.permissionType >= 0 && element.permissionType < 3);

  const line = useSelector((state) => state.line);

  const handleClick = (line) => {
    history.push(`/${actualLanguage}/lines/${line.lineId}/${line.name}`);
  };

  return (
    <CollapsiblePanel marginTop={4} isOpen={numLines === 1} withSideOverflow>
      <CollapsiblePanel.Header>
        <Title>
          <FormattedMessage id="profile.myLines.title" />
        </Title>
      </CollapsiblePanel.Header>
      <CollapsiblePanel.Body>
      {adminLines.length ? (
        <>
          <Text
            marginBottom={2}
            fontWeight="bold"
            color="#7F7F8A"
            fontSize={1}
            paddingTop={3}
          >
            <FormattedMessage id="header.imAdminLabel" />
          </Text>
          
            {adminLines.map((el) => (
                <Box
                  key={el.lineId}
                  paddingY={1}
                  onClick={() => handleClick(el)}
                  style={{ cursor: 'pointer' }}
                >
                  <CardGoneBasic
                    isAdmin={false}
                    id={el.lineId}
                    maxWidth="100%"
                    customColor={line.active?.company?.style?.primaryColor || 'orange'}
                    name={el?.name}
                    picture={el.pictures?.m}
                    date={el?.dateFrom?.year && `${el?.dateFrom?.year} - ${el?.dateTo?.year}`}
                  />
                </Box>
              ))}
          
        </>
      ) : null}
      {followerLines.length ? (
        <>
          <Text
            marginBottom={2}
            fontWeight="bold"
            color="#7F7F8A"
            fontSize={1}
            paddingTop={3}
          >
            <FormattedMessage id="header.imNotAdminLabel" />
          </Text>
          <Box>
            {followerLines.map((el) => (
                <Box
                  key={el.lineId}
                  paddingY={1}
                  onClick={() => handleClick(el)}
                  style={{ cursor: 'pointer' }}
                >
                  <CardGoneBasic
                    name={el?.name}
                    picture={el.pictures?.m}
                    customColor={line.active?.company?.style?.primaryColor || 'orange'}
                    date={el?.dateFrom?.year && `${el?.dateFrom?.year} - ${el?.dateTo?.year}`}
                  />
                </Box>
              ))}
          </Box>
        </>
      ) : null}
      </CollapsiblePanel.Body>
    </CollapsiblePanel>
  );
};

const Logout = () => {
  const dispatch = useDispatch();
  const postLogoutAPI = useCallback((lang) => dispatch(postLogout(lang)), [dispatch]);

  const handleCloseSession = () => {
    deleteLocalStorage(process.env.REACT_APP_COOKIE_LOGIN_NAME);
    // execute post logout
    postLogoutAPI(actualLanguage);
  };
  return (
  <>
    <Title>
      <FormattedMessage id="profile.logout.title" />
    </Title>
    <Box marginTop={2}>
      <Button
        marginY={1}
        fullWidth
        colorType="white"
        sizeButton="big"
        justifyContent="flex-start"
        action={() => handleCloseSession() }
      >
        <Icon sizeIcon="display24" color="black84">
          <IconPower />
        </Icon>
        <Text
          textAlign="left"
          style={{ flex: 1 }}
          marginLeft={2}
          fontWeight="bold"
          sizeText="display16"
          color="black84"
        >
          <FormattedMessage id="profile.logout.logout" />
        </Text>
      </Button>
    </Box>
  </>
)};